import { DropdownItem } from '@base-app';

export interface UseAccessibleDropdownProps {
  items: DropdownItem[];
  value: string;
  onChange: (value: DropdownItem) => void;
}

export interface UseAccessibleDropdownResult {
  activeIndex: number | undefined;
  isDropdownOpen: boolean;
  isFocus: boolean;
  listRef: any;
  select: Function;
  setActiveIndex: Function;
  setIsDropdownOpen: Function;
  setIsFocus: Function;
  registerClosedDropdownHandlers: Function;
  registerOpenDropdownHandlers: Function;
}

export interface OpenDropdownHandler {
  activeIndex: number;
  items: DropdownItem[];
  select: (option: DropdownItem) => void;
  setActiveIndex: (activeElement: number) => void;
}

export interface ClosedDropdownHandler {
  setIsDropdownOpen: (isOpen: boolean) => void;
}

export enum KEYEVENT {
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  DOWN = 'Down',
  END = 'End',
  ENTER = 'Enter',
  ESC = 'Esc',
  ESCAPE = 'Escape',
  HOME = 'Home',
  PAGE_DOWN = 'PageDown',
  PAGE_UP = 'PageUp',
  SPACE = ' ',
  UP = 'UP',
}
